import { Mail, ExternalLink } from "lucide-react";

// TEMPORARY launch workaround while the Work Gmail OAuth connection (see
// WorkGmailPanel.jsx, kept intact and untouched) is being fixed. This just
// shows the employee's work email and opens Gmail in a new tab, letting
// Google handle sign-in normally — no OAuth, no stored credentials.
export default function WorkGmailTemp({ workEmail }) {
  return (
    <section className="card-soft p-6 mb-8" data-testid="work-gmail-temp-section">
      <div className="flex items-center gap-2 mb-4">
        <Mail className="w-5 h-5" style={{ color: "var(--brand)" }} />
        <h2 className="font-serif-display text-2xl">Work Email</h2>
      </div>
      <p className="text-sm mb-1" style={{ color: "var(--text-secondary)" }}>Your assigned work mailbox</p>
      <p className="font-medium mb-4" data-testid="work-gmail-temp-address">{workEmail}</p>
      <a data-testid="work-gmail-temp-open-btn"
        href={`https://mail.google.com/mail/?authuser=${encodeURIComponent(workEmail || "")}`}
        target="_blank" rel="noopener noreferrer"
        className="btn-primary text-sm inline-flex items-center gap-2">
        Open Work Gmail <ExternalLink className="w-4 h-4" />
      </a>
    </section>
  );
}
